import { render } from "./EmployeeMoveModal.vue?vue&type=template&id=db43b5fe"
import script from "./EmployeeMoveModal.vue?vue&type=script&lang=js"
export * from "./EmployeeMoveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__